import { StoryData } from "../types/story";

// fallback will be to ireland as only the uk and ireland are supported
const regions = {
  uk: { baseURL: "https://flightclubapi.azure-api.net/uk/v2/StoryData/", key: process.env.REACT_APP_UK_KEY },
  ie: {
    baseURL: "https://irlstoryfunctions-apim.azure-api.net/StoryFunctionsIRL/StoryData/",
    key: process.env.REACT_APP_IE_KEY,
  },
};

const getStoryData = async (id: string): Promise<StoryData | null> => {
  const region = process.env.REACT_APP_REGION === "uk" ? regions.uk : regions.ie;

  try {
    const response = await fetch(`${region.baseURL}${id}`, {
      headers: {
        "Content-type": "application/json",
        "FC-Key": region.key ?? "",
      },
    });

    const text = await response.text();

    if (!response.ok || !text) {
      return null;
    }

    return JSON.parse(text);
  } catch (error) {
    return null;
  }
};

export default getStoryData;
